import { ApiResponse } from "../models/app-configuration";
import { IGraylogModel } from "../models/graylog";
import { GenericServices } from "./generic.services";


export class LogServices extends GenericServices {
    logMessage(payload: IGraylogModel): Promise<any> {
        return super.executeSelectingPost(payload, '/graylog')
            .then((response: ApiResponse) => {
                return Promise.resolve(response.data);
            }).catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }
}